var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { action, observable } from 'mobx';
import { delay, of, Subject } from 'rxjs';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from './../../libraries';
import { BarrageController } from './barrage';
import { CommentController } from './comment';
import { InfoController } from './info';
import { LikeController } from './like';
import { LiveController } from './live';
import { LuckyController } from './lucky';
import { PPTController } from './ppt';
import { ProductController } from './product';
import { ShareController } from './share';
import { SignupController } from './signup';
import { createUserModel } from './userInfo';
export class MuduController {
    constructor() {
        //弹幕
        this.Barrage = new BarrageController();
        //评论
        this.Comment = new CommentController();
        //直播间信息
        this.Info = new InfoController();
        //直播相关
        this.Live = new LiveController();
        //抽奖
        this.Lucky = new LuckyController();
        //问卷
        this.Signup = new SignupController();
        //PPT文档
        this.ppt = new PPTController();
        //点赞
        this.Like = new LikeController();
        //产品模块
        this.Product = new ProductController();
        //产品模块
        this.Share = new ShareController();
        //用户数据
        this.UserInfo = createUserModel();
        this.Player = null;
        this.playState = 'idle';
        this.muduLoading = false;
        /**
         * mudu异步数据加载订阅
         * @type {Promise<any>}
         */
        this.MuduSubject = new Subject();
    }
    //是否直播
    get isLive() {
        return lodash.eq(this.Info.liveStatus, 1);
    }
    //播放按钮是否显示
    get playShowState() {
        const isLive = lodash.eq(this.Info.liveStatus, 1);
        //idle表示播放器空闲(未开始播放), buffering表示播放器正在缓冲, playing表示播放器正在播放, paused表示播放器处于暂停播放状态。
        return ((this.playState == 'idle' || this.playState == 'paused') &&
            (this.Info.videoId || isLive));
    }
    //直播间ID
    get liveId() {
        return lodash.get(this.UserInfo.value, 'liveId');
    }
    //直播间来源
    get liveSource() {
        return lodash.get(this.UserInfo.value, 'liveSource');
    }
    //直播间来源source
    get liveSourceToken() {
        return lodash.get(this.liveSource, 'sourceCode');
    }
    get isQDDH() {
        return !lodash.eq(this.liveSourceToken, 'b415e203-4e8d-11ed-995c-0242ac110002');
    }
    get userInfo() {
        return lodash.get(this.UserInfo.value, 'userInfo', {});
    }
    get userAvatar() {
        return lodash.get(this.userInfo, 'userAvatar', 'https://iconfont.alicdn.com/t/6bfa31ff-0a40-47b9-a08d-48429f2d7b7c.png');
    }
    get userCode() {
        return lodash.get(this.userInfo, 'userCode');
    }
    get userName() {
        return lodash.get(this.userInfo, 'userName', '');
    }
    get ticket() {
        return lodash.get(this.userInfo, 'ticket', '');
    }
    onSetState(name, value) {
        this[name] = value;
    }
    onPlay() {
        try {
            this.Player.play();
        }
        catch (error) { }
    }
    onToggleLoading(value) {
        this.muduLoading = value;
    }
    /**
     * @description: 初始化直播间
     */
    async onInit(isPreview) {
        this.onToggleLoading(true);
        try {
            // this.Like.createWebsocket();
            // this.Product.createWebsocket();
            if (this.ticket) {
                window.Mudu = new MDLWebSdk(this.ticket);
            }
            else {
                window.Mudu = new MDLWebSdk();
            }
            Mudu.Init(
            // 频道id，演示频道
            `n_${this.liveId}`, () => {
                this.MuduSubject.complete();
                if (!isPreview) {
                    this.Like.onPolling();
                    this.onEnterRoom();
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * @description: 进入直播间
     */
    onEnterRoom() {
        this.getLiveUserInfo();
        this.Comment.onCommentListener();
        this.Barrage.onBarrageListener();
        this.Info.onSetRoomInfo();
        this.onRoomListener();
        this.ppt.onInit();
        this.ppt.onPPTListener();
        this.Lucky.onLuckyListener();
        this.Signup.onSignUpListener();
        this.onToggleLoading(false);
        this.Lucky.onLuckyInit();
    }
    onInitPlayer(options) {
        try {
            const playerOption = {
                // 必须，播放器容器ID，播放器会被添加到该DOM元素中
                containerId: 'livePlayer',
                // 必需， boolean 控制播放器的ui展示, 默认为false; 根据播放视频的实际情况填写
                // isLive: lodash.eq(this.Info.liveStatus, 1),
                // 非必需，isLive为false时，传入video_id，将自动匹配视频的封面和打点（进度条高亮）配置,
                // 获取视频列表接口中的"video_hash_id"
                // video_id: this.Info.videoId,
                // video_id: '1009259',
                // 播放器视频播放地址（传入video_id时，优先播放video_id对应的视频，src可不传，无video_id则必须传入src）
                // src: Mudu.Room.GetPlayAddr(),
                // 非必须，播放器海报图 string
                // image: this.Info.liveImage,
                // 非必须，播放器是否自动播放，默认false
                autoplay: true,
                // 非必须，播放器是否显示控制条，默认true
                controls: true,
                // 非必须，播放器是否循环播放, 默认false
                repeat: true,
                // 非必须，播放器宽度，单位为像素，默认为480
                width: '100%',
                // 非必须，播放器高度，单位为像素，默认为270
                height: '100%',
                // 以下x5Layer和x5Inline两个参数用于解决安卓微信、QQ、QQ浏览器的只能全屏播放的问题。参数仅对安装过tbs(腾讯浏览服务，一般安装过QQ浏览器后手机上会存在)手机生效(由于tbs的api限制，部分低版本的微信、QQ、QQ浏览器可能不会生效)，未安装tbs的安卓手机不会有只能全屏播放的问题。
                // x5Layer和x5Inline只能有一个被设置为true
                // 非必须，播放器在安卓微信、QQ、QQ浏览器中是否同层播放, 默认false  （注：同层播放时，页面document无法滚动(内部的dom元素可以)，如果播放器宽度小于浏览器宽度，两边将出现黑边）
                x5Layer: false,
                // 非必须，播放器在安卓微信、QQ、QQ浏览器中是否inline播放，默认false  （注：inline播放时，播放器始终处于z-index的最上层，因此无法在播放器上叠加元素）
                x5Inline: false,
                // 非必须 isLive为false时展示在时间进度条上的高亮点，hover时可展示text字段内容 （有video_id时自动匹配视频打点信息，若传入此字段可覆盖视频默认配置）
                renderError(err) {
                    console.log('异常', err);
                },
            };
            this.Player = new Mudu.Player(lodash.assign({}, playerOption, options));
        }
        catch (error) {
            console.log('player初始化失败', error);
        }
    }
    async onGetPlayerState() {
        await of(1).pipe(delay(999)).toPromise();
        const video = document.querySelector('video');
        if (video) {
            if (video.paused) {
                this.onSetState('playState', 'paused');
            }
            else {
                //如果是播放状态 隐藏背景
                const bg = document.querySelector('.mudu-background');
                if (bg) {
                    bg.style.display = 'none';
                }
                this.onSetState('playState', 'playing');
            }
        }
        else {
            //如果video不存在 显示背景
            const bg = document.querySelector('.mudu-background');
            if (bg) {
                bg.style.display = 'block';
            }
            this.onSetState('playState', 'paused');
        }
    }
    onPlayerListener(readycallback, playcallback) {
        Mudu.MsgBus.On(
        // 事件名，值为Player.Ready
        'Player.Ready', 
        // 事件处理函数，参数为当前player组件对象
        (player) => {
            this.onPlayerReload();
            this.Live.onToggleLoading(false);
            this.onSetState('playState', this.Player.getState());
            if (readycallback) {
                readycallback.bind(this)();
            }
        });
        Mudu.MsgBus.On(
        // 事件名，值为Player.Play
        'Player.Play', 
        // 事件处理函数，参数为当前player组件对象
        (player) => {
            if (playcallback) {
                playcallback.bind(this)();
            }
            this.onGetPlayerState();
        });
        Mudu.MsgBus.On(
        // 事件名，值为Room.StreamEvent
        'Room.StreamEvent', 
        // 事件处理函数，参数类型为object
        async (msg) => {
            const data = JSON.parse(msg);
            //data.event为1 开启直播
            if (lodash.eq(data.event, 1)) {
                await of(1).pipe(delay(5000)).toPromise();
                try {
                    await this.getLiveStreamingNotice(this.Info.playAddr);
                    this.onPlayerReload();
                }
                catch (error) { }
            }
            else {
                await of(1).pipe(delay(2000)).toPromise();
                this.onPlayerReload();
            }
        });
        Mudu.MsgBus.On(
        // 事件名，值为Player.Play
        'Player.Stoped', 
        // 事件处理函数，参数为当前player组件对象
        (player) => {
            this.onGetPlayerState();
        });
    }
    onRoomListener() {
        Mudu.MsgBus.On('Room.ListLiveEvent', () => {
            this.onPlayerReload();
        });
    }
    async onPlayerReload() {
        this.Info.onSetRoomInfo();
        const isLive = lodash.eq(this.Info.liveStatus, 1);
        const playerOptions = {};
        //存在回看视频
        if (this.Info.videoId && !isLive) {
            lodash.set(playerOptions, 'video_id', this.Info.videoId);
        }
        //存在直播
        if (this.Info.playAddr && isLive) {
            lodash.set(playerOptions, 'file', this.Info.playAddr);
        }
        if (this.Info.liveImage) {
            lodash.set(playerOptions, 'image', this.Info.liveImage);
        }
        if (playerOptions.file || playerOptions.video_id) {
            this.Player.load([
                lodash.assign({}, {
                    autoplay: true,
                    // isLive 必需 boolean 控制播放器的ui展示,默认为false; 根据播放视频的实际情况填写
                    isLive,
                    // 非必需，isLive为false时，传入video_id，将自动匹配视频的封面和打点（进度条高亮）配置
                    // 播放器视频播放地址（传入video_id时，优先播放video_id对应的视频，file可不传，无video_id则必须传入file）
                    // file: this.Info.playAddr,
                    // 非必需，视频封面：有video_id时将自动匹配video对应封面，若传入此字段可覆盖视频默认配置
                    // 非必需，isLive为false时展示在时间进度条上的高亮点，hover时可展示text字段内容 （有video_id时自动匹配视频打点信息，若传入此字段可覆盖视频默认配置）
                    // controls: true,
                }, playerOptions),
            ]);
        }
        else {
            this.Player.stop();
        }
        this.onGetPlayerState();
    }
    /**
     * 获取直播间登录用户信息
     * @returns
     */
    async getLiveUserInfo() {
        const userInfo = Mudu.Room.User.GetUser();
        console.log(userInfo, 'userInfo');
        const userCode = (Math.random() + new Date().getTime())
            .toString(32)
            .slice(0, 8);
        try {
            //如果是游客 生成随机code
            this.UserInfo.merge({
                userInfo: lodash.assign({}, { userCode: userCode }, {
                    userCode: userInfo.outer_id,
                    userAvatar: userInfo.avatar,
                    userName: userInfo.name,
                }),
            });
        }
        catch (error) {
            if (!this.userCode) {
                //如果失败了 生成随机code
                this.UserInfo.merge({
                    userInfo: lodash.assign({}, { userCode: userCode, userName: '游客' }),
                });
            }
        }
    }
    /**
     * 获取直播间登录用户ticket
     * @returns
     */
    async getLiveTicket() {
        try {
            const res = await AjaxBasics.request(lodash.assign({}, EnumAPI.live_user, {
                body: {
                    liveId: this.liveId,
                },
            }));
            this.UserInfo.merge({
                userInfo: lodash.assign({}, { ticket: res.ticket }),
            });
        }
        catch (error) { }
    }
    /**
     * 查询视频流是否可用
     * @returns
     */
    async getLiveStreamingNotice(url) {
        return await AjaxBasics.request(lodash.assign(EnumAPI.live_streaming_notice, {
            body: { url },
        }));
    }
    async onGetLiveSource(id) {
        const res = await AjaxBasics.request(lodash.assign(EnumAPI.live_source, {
            body: { liveId: id },
        }));
        this.UserInfo.merge({ liveSource: res });
    }
    /**
     * @description: 校验直播间权限
     */
    async onLivePermission(id) {
        if (lodash.isNil(id)) {
            console.warn('没有直播间ID');
            throw { status: '403' };
        }
        else {
            await this.onGetLiveSource(id);
            const res = await AjaxBasics.request(lodash.assign(this.isQDDH ? EnumAPI.live_auto_user : EnumAPI.live_check_auth, {
                body: { liveId: id },
            }));
            if (res) {
                this.UserInfo.merge({ liveId: id });
                await this.Live.getLiveRoomInfo();
                await this.Live.getLiveEmoji();
                await this.getLiveTicket();
            }
            else {
                throw { status: '403' };
            }
        }
    }
}
__decorate([
    observable
], MuduController.prototype, "playState", void 0);
__decorate([
    observable
], MuduController.prototype, "muduLoading", void 0);
__decorate([
    action.bound
], MuduController.prototype, "onSetState", null);
__decorate([
    action.bound
], MuduController.prototype, "onToggleLoading", null);
